import { render, staticRenderFns } from "./Pagenation.vue?vue&type=template&id=78ac703c&scoped=true&"
import script from "./Pagenation.vue?vue&type=script&lang=js&"
export * from "./Pagenation.vue?vue&type=script&lang=js&"
import style0 from "./Pagenation.vue?vue&type=style&index=0&id=78ac703c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ac703c",
  null
  
)

export default component.exports